import React from "react";
import { Trans } from "react-i18next";

const CreateProductFormStep: React.FC = () => {
    return (
        <p className="fs-7 mb-0">
            <Trans
                i18nKey="tutorial.createProductFormStep"
                components={{
                    strong: <strong />,
                    asterisk: (
                        <span>
                            {" "}
                            (<span className="text-danger">*</span>){" "}
                        </span>
                    ),
                }}
            />
        </p>
    );
};

export default CreateProductFormStep;
